/** @jsx jsx */
import { Box, Flex, Text, jsx, Grid } from "theme-ui";
import React, { PropsWithChildren, useEffect } from "react";
import HtmlContent from "../../components/html-render/html-content";
import BuilderImage from "../image/builder-image";

type HeroProps = { message: string; image: string } & PropsWithChildren;
export const PageHero: React.FC<HeroProps> = ({ message, children, image }) => {
  const HERO_HEIGHT = ["120px", "250px", "584px"];

  //const heroFadeIn = backgroundVideo ? FadeIn(2000, 8000) : FadeIn();
  //return null;

  let background;

  background = (
    <Flex
      sx={{
        position: "relative",
        justifyContent: "center",
        gridArea: "1/1",
        width: "100%",
      }}
    >
      <Box
        sx={{
          // height: HERO_HEIGHT,
          width: "100%",
        }}
      >
        {/*  <img src={image} alt="hero image of cartoon trail route" loading="eager" height={350}></img> */}
        <BuilderImage
          url={image}
          alt={"hero image of cartoon trail route"}
          lazy={false}
          fetchPriority="high"
          aspectRatio="2000/608"
        />
        {/*  <Image priority src={image} alt="Builder.io drag and drop interface" /> */}
      </Box>
      {/* <Image
        objectFit="cover"
        objectPosition="center top"
        sx={{
          //height: HERO_HEIGHT,
          width: "100%",
        }}
        loading="eager"
        image={
          backgroundImage.localFile
        }
        alt={backgroundImage.altText || backgroundImage.title || "hero image"}
      /> */}
    </Flex>
  );

  return (
    <Box as="section">
      <Grid>
        {background}
        <Grid sx={{ position: "relative", gridArea: "1/1" }}>
          <Flex
            variant="layout.box"
            sx={{
              justifyContent: "center",
              alignItems: "flex-start",
              //height: { HERO_HEIGHT },
            }}
          >
            <Box id="caption" variant="hero.contentWrapper" sx={{ zIndex: 15 }}>
              <Text as="h1" variant="hero.message">
                <HtmlContent html={message || ""} />
              </Text>
            </Box>
          </Flex>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PageHero;
